import type { CiteKnowledge } from 'services/api/supplementKnowledge';

type Citation = Pick<CiteKnowledge, 'knowledgeId' | 'knowledgeType' | 'source'>;

const supplementalSources = new Set([
  'CUSTOMER',
  'AI_ERROR_REPLY',
  'HISTORY_CUSTOMER',
  'CIH_HISTORY_CUSTOMER',
  'MERCADO_QA',
  '客服提交答案',
  'AI回复错误',
  '主管提交历史未回复问题答案',
  'CIH提交历史未回复问题答案',
  '美客多Q&A',
]);
const legacyDetailSources = new Set([
  '商品详情页',
  '商品详情页_人工修改',
  '商家外部知识导入',
  '商家线上文档同步',
]);
const stableTypes = new Set([
  'supplemental_knowledge',
  'spu_detail_knowledge',
  'document_knowledge',
  'product_detail_knowledge',
]);

/** 与 knowledge 服务一致：稳定类型优先，历史引用再按来源兜底。 */
export const resolveKnowledgeType = (knowledge: Pick<Citation, 'knowledgeType' | 'source'>) => {
  const type = knowledge.knowledgeType?.trim().toLowerCase();
  if (type && stableTypes.has(type)) return type;
  const source = knowledge.source?.trim();
  if (supplementalSources.has(source?.toUpperCase())) return 'supplemental_knowledge';
  if (source === 'SPU详情知识V2') return 'spu_detail_knowledge';
  if (source === '文档知识') return 'document_knowledge';
  if (legacyDetailSources.has(source)) return 'product_detail_knowledge';
  return undefined;
};

/** 新版商品知识：商详 V2 / 文档知识 */
export const isNewProductKnowledge = (knowledge: Pick<Citation, 'knowledgeType' | 'source'>) => {
  const type = resolveKnowledgeType(knowledge);
  return type === 'spu_detail_knowledge' || type === 'document_knowledge';
};

/** 停用（而非删除）即完成下线的知识：仅补充知识；商详 V2 / 文档知识走真实删除。 */
export const usesDisableOperation = (knowledge: Pick<Citation, 'knowledgeType' | 'source'>) =>
  resolveKnowledgeType(knowledge) === 'supplemental_knowledge';

export const knowledgeIdentity = (knowledge: Citation) =>
  `${resolveKnowledgeType(knowledge) ?? knowledge.source}:${knowledge.knowledgeId}`;

export const isSameKnowledge = (left: Citation, right: Citation) =>
  left.knowledgeId != null &&
  right.knowledgeId != null &&
  knowledgeIdentity(left) === knowledgeIdentity(right);
